import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addSupplier = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Supplier', body);
  return data;
});
export const updateSupplier = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Supplier/${id}`,
    body
  );
  return data;
});

export const getSupplier = catchAsync(
  async ({ key = '', value = '', pageCount = 1 }) => {
    // let baseUrl = `/api/resource/Supplier?fields=["supplier_name","name","supplier_name_in_arabic","country","on_hold","supplier_group","tax_id"]&limit_start=0&limit_page_length=0&page=${pageCount}`;
    // let baseUrl = `/api/resource/Supplier?fields=["supplier_name","supplier_name_in_arabic","name","on_hold","country","tax_id"]&limit_start=0&limit_page_length=0&page=${pageCount}`;
    let baseUrl = `/api/resource/Supplier?fields=["supplier_name","name","on_hold","country","tax_id"]&limit_start=0&limit_page_length=0&page=${pageCount}`;
    if (value) {
      baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
    }
    const { data } = await axiosInstance.get(baseUrl);
    return data;
  }
);
export const deleteSupplier = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Supplier/${record}`
  );
  return data;
});
export const getSupplierDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Supplier/${id}`);
  return data;
});
export const getPriceListsSupplier = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_price_lists?filters={"buying":1}`
  );
  return data;
});
